import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  applyTraits
} from 'utilities/javascript';

import DataManagerTraits from '../traits';

class DataCollectionsManager {

  constructor(application) {

    this.initialized = false;
    this.collection = [];

    this.application = application;

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.collection);

  }

  handleUpdatedEvent(payload) {

    this.tryRemove(payload.collection._id);
    this.tryAdd(payload.collection);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.collection._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.DATA_COLLECTION_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.DATA_COLLECTION_UPDATED, this.handleUpdatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.DATA_COLLECTION_DELETED, this.handleDeletedEvent.bind(this));

  }

  async loadAll() {

    this.collection = await serverInterface.startup.dataCollections.getAllDataCollections();

  }

  async create(payload) {

    let item = await serverInterface.startup.forms.createForm(payload);

    this.tryAdd(item);

    return item;

  }

  async delete(itemId) {

    await serverInterface.startup.forms.deletePromotionCode(itemId);

    this.tryRemove(itemId);

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.collection = bootstrapData.dataCollections;

    this.initialized = true;

  }

}

export default applyTraits(DataCollectionsManager, [DataManagerTraits]);